"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyEmailAfterEmailChange = exports.verifyEmail = exports._verifyEmail = void 0;
var Auth_1 = __importDefault(require("../../auth/Auth"));
var http_1 = require("../../http/http");
var service_1 = __importDefault(require("../service"));
var _verifyEmail = function (verificationToken, isEmailUpdate) {
    return ((0, http_1.create)(service_1.default.baseUrl, {
        headers: service_1.default.getDefaultHeaders(false),
    }).post('/verify-email', {
        verificationToken: verificationToken,
        isEmailUpdate: isEmailUpdate,
    }))
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
exports._verifyEmail = _verifyEmail;
var verifyEmail = function (verificationToken) { return (0, exports._verifyEmail)(verificationToken, false)
    .then(Auth_1.default.instance.onLoginHook.bind(Auth_1.default.instance)); };
exports.verifyEmail = verifyEmail;
var verifyEmailAfterEmailChange = function (verificationTokenEmailChange) { return (0, exports._verifyEmail)(verificationTokenEmailChange, true)
    .then(function (data) {
    if (Auth_1.default.instance.user) {
        Auth_1.default.instance.onUserUpdateHook(__assign(__assign({}, Auth_1.default.instance.user), { email: data.email }));
    }
    return data;
}); };
exports.verifyEmailAfterEmailChange = verifyEmailAfterEmailChange;
exports.default = exports.verifyEmail;
